// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .category-tabs {
  display: block;
  padding: 0 20px;
  margin-bottom: 10px;
}
:host flw-breadcrumb {
  display: block;
  padding: 0 var(--space-xl);
  margin-bottom: 10px;
}
:host flw-family-selector {
  display: block;
  padding: 0 20px;
  margin-bottom: 10px;
}
:host .gift-info-banner {
  display: block;
  padding: 0 20px;
}
:host ion-list {
  background: var(--ion-color-background);
}
:host ion-list.productsWithFamilies {
  padding-top: 0 !important;
}
:host ion-list.familiesWithProducts {
  padding-bottom: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/wizard/family-product-list/family-product-list.component.scss"],"names":[],"mappings":"AACI;EACI,cAAA;EACA,eAAA;EACA,mBAAA;AAAR;AAGI;EACI,cAAA;EACA,0BAAA;EACA,mBAAA;AADR;AAII;EACI,cAAA;EACA,eAAA;EACA,mBAAA;AAFR;AAKI;EACI,cAAA;EACA,eAAA;AAHR;AAMI;EACI,uCAAA;AAJR;AAMI;EACI,yBAAA;AAJR;AAOI;EACI,4BAAA;AALR","sourcesContent":[":host {\r\n    .category-tabs {\r\n        display: block;\r\n        padding: 0 20px;\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n    flw-breadcrumb {\r\n        display: block;\r\n        padding: 0 var(--space-xl);\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n    flw-family-selector {\r\n        display: block;\r\n        padding: 0 20px;\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n    .gift-info-banner {\r\n        display: block;\r\n        padding: 0 20px;\r\n    }\r\n\r\n    ion-list{\r\n        background: var(--ion-color-background);\r\n    }\r\n    ion-list.productsWithFamilies {\r\n        padding-top: 0 !important;\r\n    }\r\n\r\n    ion-list.familiesWithProducts {\r\n        padding-bottom: 0 !important;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
